/**
 * Venttra CMS - Shared constants
 */

export const CONTENT_LOCALES = ["en", "de", "fr", "it"] as const;
export type ContentLocale = (typeof CONTENT_LOCALES)[number];

export const LOCALE_LABELS: Record<ContentLocale, string> = {
  en: "English",
  de: "German",
  fr: "French",
  it: "Italian",
};
